// Mock data for KETUA BARBERSHOP

export const translations = {
  id: {
    nav: {
      home: 'Beranda',
      services: 'Layanan',
      styles: 'Model Rambut',
      gallery: 'Galeri',
      testimonials: 'Testimoni',
      contact: 'Kontak',
      book: 'Booking Sekarang'
    },
    hero: {
      title: 'KETUA BARBERSHOP',
      subtitle: 'Gaya Premium, Potongan Sempurna',
      description: 'Pengalaman barbershop terbaik di Medan dengan sentuhan profesional dan gaya modern',
      cta: 'Booking Sekarang',
      cta2: 'Lihat Layanan'
    },
    services: {
      title: 'Layanan & Harga',
      subtitle: 'Pilihan layanan premium untuk penampilan terbaik Anda'
    },
    styles: {
      title: 'Model & Jenis Pangkas',
      subtitle: 'Berbagai pilihan gaya rambut sesuai kepribadian Anda'
    },
    gallery: {
      title: 'Galeri Kami',
      subtitle: 'Hasil karya terbaik dari tim profesional kami'
    },
    testimonials: {
      title: 'Apa Kata Pelanggan',
      subtitle: 'Kepuasan pelanggan adalah prioritas kami'
    },
    booking: {
      title: 'Reservasi Online',
      subtitle: 'Booking jadwal Anda sekarang',
      name: 'Nama Lengkap',
      phone: 'Nomor Telepon',
      date: 'Pilih Tanggal',
      time: 'Pilih Waktu',
      service: 'Pilih Layanan',
      submit: 'Konfirmasi Booking',
      success: 'Booking berhasil! Kami akan menghubungi Anda segera.'
    },
    contact: {
      title: 'Hubungi Kami',
      address: 'Alamat',
      phone: 'Telepon',
      hours: 'Jam Operasional',
      social: 'Ikuti Kami'
    },
    footer: {
      tagline: 'Gaya Premium, Potongan Sempurna',
      rights: '© 2025 KETUA BARBERSHOP. All rights reserved.'
    }
  },
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      styles: 'Hair Styles',
      gallery: 'Gallery',
      testimonials: 'Testimonials',
      contact: 'Contact',
      book: 'Book Now'
    },
    hero: {
      title: 'KETUA BARBERSHOP',
      subtitle: 'Premium Style, Perfect Cut',
      description: 'The best barbershop experience in Medan with professional touch and modern style',
      cta: 'Book Now',
      cta2: 'View Services'
    },
    services: {
      title: 'Services & Prices',
      subtitle: 'Premium service options for your best appearance'
    },
    styles: {
      title: 'Hair Styles & Types',
      subtitle: 'Various hairstyle options to match your personality'
    },
    gallery: {
      title: 'Our Gallery',
      subtitle: 'Best works from our professional team'
    },
    testimonials: {
      title: 'What Customers Say',
      subtitle: 'Customer satisfaction is our priority'
    },
    booking: {
      title: 'Online Reservation',
      subtitle: 'Book your appointment now',
      name: 'Full Name',
      phone: 'Phone Number',
      date: 'Select Date',
      time: 'Select Time',
      service: 'Select Service',
      submit: 'Confirm Booking',
      success: 'Booking successful! We will contact you soon.'
    },
    contact: {
      title: 'Contact Us',
      address: 'Address',
      phone: 'Phone',
      hours: 'Operating Hours',
      social: 'Follow Us'
    },
    footer: {
      tagline: 'Premium Style, Perfect Cut',
      rights: '© 2025 KETUA BARBERSHOP. All rights reserved.'
    }
  }
};

export const services = [
  {
    id: 1,
    name: {
      id: 'Haircut Regular',
      en: 'Regular Haircut'
    },
    price: 'Rp 45.000',
    duration: '30 min',
    description: {
      id: 'Potongan rambut standar dengan hasil profesional',
      en: 'Standard haircut with professional results'
    },
    icon: 'Scissors'
  },
  {
    id: 2,
    name: {
      id: 'Haircut Premium',
      en: 'Premium Haircut'
    },
    price: 'Rp 65.000',
    duration: '45 min',
    description: {
      id: 'Potongan rambut premium dengan konsultasi styling',
      en: 'Premium haircut with styling consultation'
    },
    icon: 'Sparkles'
  },
  {
    id: 3,
    name: {
      id: 'Haircut + Styling',
      en: 'Haircut + Styling'
    },
    price: 'Rp 85.000',
    duration: '60 min',
    description: {
      id: 'Potongan rambut lengkap dengan styling dan produk premium',
      en: 'Complete haircut with styling and premium products'
    },
    icon: 'Star'
  },
  {
    id: 4,
    name: {
      id: 'Shaving + Facial',
      en: 'Shaving + Facial'
    },
    price: 'Rp 55.000',
    duration: '40 min',
    description: {
      id: 'Cukur halus dengan perawatan wajah',
      en: 'Clean shave with facial treatment'
    },
    icon: 'Razor'
  },
  {
    id: 5,
    name: {
      id: 'Haircut + Shaving',
      en: 'Haircut + Shaving'
    },
    price: 'Rp 95.000',
    duration: '70 min',
    description: {
      id: 'Paket lengkap potongan rambut dan cukur',
      en: 'Complete package haircut and shave'
    },
    icon: 'Package'
  },
  {
    id: 6,
    name: {
      id: 'Hair Coloring',
      en: 'Hair Coloring'
    },
    price: 'Rp 150.000',
    duration: '90 min',
    description: {
      id: 'Pewarnaan rambut profesional dengan produk berkualitas',
      en: 'Professional hair coloring with quality products'
    },
    icon: 'Palette'
  }
];

export const hairStyles = [
  {
    id: 1,
    name: 'Fade',
    description: {
      id: 'Potongan gradasi halus dari pendek ke panjang',
      en: 'Smooth gradient from short to long'
    },
    popularity: 'high',
    image: 'https://images.unsplash.com/photo-1622286342621-4bd786c2447c?w=400'
  },
  {
    id: 2,
    name: 'Undercut',
    description: {
      id: 'Samping dan belakang pendek, atas tetap panjang',
      en: 'Short sides and back, long top'
    },
    popularity: 'high',
    image: 'https://images.unsplash.com/photo-1605497788044-5a32c7078486?w=400'
  },
  {
    id: 3,
    name: 'Pompadour',
    description: {
      id: 'Gaya klasik dengan volume di bagian depan',
      en: 'Classic style with volume at the front'
    },
    popularity: 'medium',
    image: 'https://images.unsplash.com/photo-1621605815971-fbc98d665033?w=400'
  },
  {
    id: 4,
    name: 'Quiff',
    description: {
      id: 'Rambut depan terangkat dengan tekstur natural',
      en: 'Front hair lifted with natural texture'
    },
    popularity: 'medium',
    image: 'https://images.unsplash.com/photo-1599351431202-1e0f0137899a?w=400'
  },
  {
    id: 5,
    name: 'Buzz Cut',
    description: {
      id: 'Potongan sangat pendek, praktis dan maskulin',
      en: 'Very short cut, practical and masculine'
    },
    popularity: 'medium',
    image: 'https://images.unsplash.com/photo-1621607512214-68297480165e?w=400'
  },
  {
    id: 6,
    name: 'Textured Crop',
    description: {
      id: 'Potongan modern dengan tekstur acak',
      en: 'Modern cut with textured finish'
    },
    popularity: 'high',
    image: 'https://images.unsplash.com/photo-1620926994907-c481c2b1e07c?w=400'
  },
  {
    id: 7,
    name: 'Slick Back',
    description: {
      id: 'Rambut disisir ke belakang untuk tampilan formal',
      en: 'Hair combed back for formal appearance'
    },
    popularity: 'medium',
    image: 'https://images.unsplash.com/photo-1618747683496-b2c6c7e9f7c6?w=400'
  },
  {
    id: 8,
    name: 'Side Part',
    description: {
      id: 'Gaya klasik dengan belahan samping',
      en: 'Classic style with side part'
    },
    popularity: 'medium',
    image: 'https://images.unsplash.com/photo-1619604890989-23e8f04f0c7f?w=400'
  }
];

export const galleryImages = [
  {
    id: 1,
    url: 'https://images.unsplash.com/photo-1536520002442-39764a41e987?w=600',
    alt: 'Luxury barbershop interior',
    category: 'interior'
  },
  {
    id: 2,
    url: 'https://images.unsplash.com/photo-1585747860715-2ba37e788b70?w=600',
    alt: 'Professional haircut service',
    category: 'service'
  },
  {
    id: 3,
    url: 'https://images.unsplash.com/photo-1621645582931-d1d3e6564943?w=600',
    alt: 'Modern barbershop setup',
    category: 'interior'
  },
  {
    id: 4,
    url: 'https://images.pexels.com/photos/18173343/pexels-photo-18173343.jpeg?w=600',
    alt: 'Barber at work',
    category: 'service'
  },
  {
    id: 5,
    url: 'https://images.pexels.com/photos/7195807/pexels-photo-7195807.jpeg?w=600',
    alt: 'Professional styling',
    category: 'service'
  },
  {
    id: 6,
    url: 'https://images.unsplash.com/photo-1647140655214-e4a2d914971f?w=600',
    alt: 'Expert barber service',
    category: 'service'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Andi Pratama',
    rating: 5,
    text: {
      id: 'Pelayanan sangat memuaskan! Barbernya profesional dan hasilnya selalu rapi. Tempatnya juga nyaman dan bersih.',
      en: 'Very satisfying service! Professional barbers and always neat results. The place is also comfortable and clean.'
    },
    date: '2025-01-15'
  },
  {
    id: 2,
    name: 'Budi Santoso',
    rating: 5,
    text: {
      id: 'Barbershop terbaik di Medan! Harganya reasonable dan hasilnya memuaskan. Recommended banget!',
      en: 'Best barbershop in Medan! Reasonable prices and satisfying results. Highly recommended!'
    },
    date: '2025-01-10'
  },
  {
    id: 3,
    name: 'Chandra Wijaya',
    rating: 5,
    text: {
      id: 'Sudah langganan di sini 2 tahun. Konsisten bagus dan barbernya ramah. Tempatnya juga strategis.',
      en: 'Been a regular here for 2 years. Consistently good and friendly barbers. Strategic location too.'
    },
    date: '2025-01-05'
  },
  {
    id: 4,
    name: 'Dimas Prakoso',
    rating: 5,
    text: {
      id: 'Pelayanannya cepat dan hasilnya sesuai ekspektasi. Sistem booking online juga memudahkan.',
      en: 'Fast service and results meet expectations. Online booking system is also convenient.'
    },
    date: '2024-12-28'
  }
];

export const contactInfo = {
  address: 'Jl. Bromo No.54 B, Medan, 20226, ID',
  phone: '+62 813-6789-0123',
  whatsapp: '+6281367890123',
  email: 'info@ketuabarbershop.com',
  hours: {
    id: {
      weekday: 'Senin - Sabtu: 09:00 - 21:00',
      weekend: 'Minggu: 10:00 - 18:00'
    },
    en: {
      weekday: 'Monday - Saturday: 09:00 - 21:00',
      weekend: 'Sunday: 10:00 - 18:00'
    }
  },
  social: {
    instagram: 'https://instagram.com/ketuabarbershop',
    facebook: 'https://facebook.com/ketuabarbershop',
    tiktok: 'https://tiktok.com/@ketuabarbershop'
  },
  maps: 'https://maps.google.com/?q=Jl.+Bromo+No.54+B,+Medan,+20226'
};

export const timeSlots = [
  '09:00', '09:30', '10:00', '10:30', '11:00', '11:30',
  '12:00', '12:30', '13:00', '13:30', '14:00', '14:30',
  '15:00', '15:30', '16:00', '16:30', '17:00', '17:30',
  '18:00', '18:30', '19:00', '19:30', '20:00', '20:30'
];
